export default {
  title: '我的分享',

  menuMusic: '音乐分享',
  menuLib: '歌单分享',
  menuSinger: '音乐人分享',

  tableEmtpy: '暂无音乐分享记录，快去全部音乐看看吧～',
}